var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderNeutralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4383 80.8765C62.7717 80.8765 80.8765 62.7717 80.8765 40.4383C80.8765 18.1048 62.7717 0 40.4383 0C18.1048 0 0 18.1048 0 40.4383C0 62.7717 18.1048 80.8765 40.4383 80.8765Z",
    fill: "#ECEFF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4402_33008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 81
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4383 80.8765C62.7717 80.8765 80.8765 62.7717 80.8765 40.4383C80.8765 18.1048 62.7717 0 40.4383 0C18.1048 0 0 18.1048 0 40.4383C0 62.7717 18.1048 80.8765 40.4383 80.8765Z",
    fill: "#ECEFF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4402_33008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5475 51.3265C48.8435 51.3265 55.5687 44.6013 55.5687 36.3053C55.5687 28.0094 48.8435 21.2842 40.5475 21.2842C32.2516 21.2842 25.5264 28.0094 25.5264 36.3053C25.5264 44.6013 32.2516 51.3265 40.5475 51.3265Z",
    fill: "#2EBBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7132 66.6856C52.8144 52.5006 28.2749 52.5006 11.3761 66.6856C10.8253 67.1513 10.5049 67.8322 10.5049 68.5582C10.5049 70.9766 10.5049 76.8249 10.5049 81.1059C10.5049 83.8698 12.748 86.1079 15.5119 86.1079H65.5824C68.3463 86.1079 70.5894 83.8698 70.5894 81.1059V69.5396C70.5894 67.8322 70.269 67.1513 69.7132 66.6856Z",
    fill: "#2EBBEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderNeutralIcon);
export default __webpack_public_path__ + "static/media/genderNeutralIcon.78aabc36ba7f582494093eb22fe8db10.svg";
export { ForwardRef as ReactComponent };